/* eslint-disable */
import ko from 'knockout';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/editorial-appeal');
var s$Appeal = window.globalLegacySchema.get('Appeal');
var ViewModel = function (options) {
  this.options = options || ({});
  this.provideJustification = ko.observable(this.options.provideJustification || false);
  this.rejectedReasons = ko.observableArray(this.options.rejectedReasons);
  this.rejectedTerms = ko.observableArray(this.options.rejectedTerms);
  ko_schema.properties(this, s$Appeal, ['JustificationText'], {
    JustificationText: this.options.justification || ''
  });
};
export default ViewModel;

